export default __webpack_public_path__ + "static/media/homeImage3.0961d1d1.jpeg";